<template>
  <div id="leftNav" class="scrollthumb" v-loading="loading"
    :element-loading-text="config.loading.text"
    :element-loading-spinner="config.loading.spinner"
    :element-loading-background="config.loading.background">
    <div class="colltab" @click="collfunc">
      <i v-if="isCollapse" class="el-icon-s-unfold"></i>
      <i v-else class="el-icon-s-fold"></i>
    </div>
    <el-menu
      :default-active="activeIndex"
      class="el-menu-vertical-demo"
      :collapse-transition="false"
      :unique-opened="true"
      @select="handleSelect"
      :collapse="isCollapse"
    >
      <template v-for="item in nowNav">
        <el-menu-item v-if="!item.children" :key="item.moduleType" :index="item.path">
          <i :class="['iconfont', item.icon]"></i>
          <span slot="title">{{ item.name }}</span>
        </el-menu-item>
        <el-submenu v-else :key="item.moduleType" :index="item.path">
          <template slot="title">
            <i :class="['iconfont', item.icon]"></i>
            <span slot="title">{{ item.name }}</span>
          </template>
          <template v-for="itemc in item.children">
            <el-menu-item
              v-if="!itemc.children"
              :key="itemc.moduleType"
              :index="itemc.path"
              >{{ itemc.name }}</el-menu-item
            >
            <el-submenu v-else :key="itemc.moduleType" :index="itemc.path">
              <template slot="title">{{ itemc.name }}</template>
              <el-menu-item
                v-for="itemd in itemc.children"
                :key="itemd.moduleType"
                :index="itemd.path"
                >{{ itemd.name }}
              </el-menu-item>
            </el-submenu>
          </template>
        </el-submenu>
      </template>
    </el-menu>
  </div>
</template>
<script>
import NavConfig from "@/utils/navconfig";
import Config from "@/utils/config";
import { arrayInclude } from "@/utils/util";
import { httpToken } from "@/utils/http";
import qs from "qs";
export default {
  name: "LeftNav",
  data() {
    return {
      loading:false,
      activeIndex: "",
      nowNav: "",
      isCollapse: false,
    };
  },
  mounted() {
    if (sessionStorage.getItem("isCollapse")) {
      this.isCollapse = JSON.parse(sessionStorage.getItem("isCollapse"));
    }
    this.getNavPermission(this.$store.state.mainNav)
  },
  methods: {
    // 获取当前模块权限
    getNavPermission(nav){
      this.loading=true
      let permissionall = JSON.parse(sessionStorage.getItem("permissionall"));
      httpToken({
        url: "/sys-permission/findPermissionTreeByRoleAndParent",
        method: "post",
        data:qs.stringify({
          id:Number(permissionall[nav].id) 
        })
      }).then((res) => {
        this.nowNav =res.data.data
        this.navSelect(this.nowNav)
        this.loading=false
      }).catch(()=>{
        this.loading=false
      })
    },
    navSelect(data){
      if(data[0].children){
        this.navSelect(data[0].children)
      }else{
        this.handleSelect(data[0].path)
      }
    },
    collfunc() {
      let isCollapse = !this.isCollapse;
      sessionStorage.setItem("isCollapse", isCollapse);
      this.isCollapse = isCollapse;
    },
    handleSelect(e) {
      console.log('e',e)
      let u = "";
      let r = e.split("/");
      if (!r[4]) {
        if (!r[3]) {
          u = r[2];
        } else {
          if (r[2] == r[3]) {
            u = r[2];
          } else {
            u = r[2] + r[3].replace(r[3][0], r[3][0].toUpperCase());
          }
        }
      } else {
        u =
          r[2] +
          r[3].replace(r[3][0], r[3][0].toUpperCase()) +
          r[4].replace(r[4][0], r[4][0].toUpperCase());
      }
      this.activeIndex = e;
      this.$store.commit("setLeftNav", u.replace(u[0], u[0].toUpperCase()));
    },
  },
  watch: {
    "$store.state.leftNav": {
      handler: function (newVal, oldVal) {
        if (newVal === "") {
          return;
        }
        if (newVal != oldVal) {
          let mainNav = this.$store.state.mainNav.toLowerCase();
          let path = newVal.replace(/([A-Z])/g, "/$1").toLowerCase();
          this.activeIndex = "/" + mainNav + path;
          console.log('this.activeIndex',this.activeIndex)
        }
      },
    },
  },
};
</script>
<style lang="scss" scoped>
#leftNav {
  // width: 226px;
  // min-width: 226px;
  height: calc(100vh - 66px);
  line-height: 48px;
  border-right: 1px solid #e6e6e6;
  padding-top: 7px;
  box-sizing: border-box;
  color: #fff;
  background-color: #376bf4;
  overflow-y: scroll;

  .colltab {
    text-align: center;
    cursor: pointer;
  }

  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 226px;
    min-width: 226px;
  }

  .el-menu {
    color: #fff;
    background-color: #376bf4;
    border-right: 0;

    ::v-deep .el-submenu__title {
      font-size: 17px;
      font-weight: bold;
      display: flex;
      align-items: center;
      color: #fff;
    }

    ::v-deep .el-submenu__title:hover {
      background-color: #2557db;
    }

    ::v-deep i {
      color: #fff;
    }

    .el-menu-item {
      color: #fff;
      background-color: #376bf4;
      font-size: 17px;
      font-weight: bold;
      display: flex;
      align-items: center;
    }

    .el-menu-item.is-active,
    .el-submenu.is-active {
      color: #fff;
      background-color: #2557db;
      border-right: 2px solid #fff;
    }

    .el-menu-item:hover,
    .el-menu-item:active {
      color: #fff;
      background-color: #2557db;
    }

    .el-submenu .el-menu .el-menu-item {
      font-weight: normal;
      font-size: 16px;
    }

    .el-submenu {
      color: #fff;
      background-color: #376bf4;

      ::v-deep .el-menu {
        color: #fff;
        background-color: #376bf4;
      }

      ::v-deep .el-submenu .el-submenu__title {
        color: #fff;
        background-color: #376bf4;
        font-size: 17px;
        text-indent: 10px;
        font-weight: normal;
      }

      ::v-deep .el-submenu .el-menu-item {
        color: #fff;
        background-color: #376bf4;
        font-size: 16px;
      }
    }

    ::v-deep img {
      margin-right: 10px;
      width: 20px;
      height: 20px;
      image-rendering: -moz-crisp-edges; /* Firefox */
      image-rendering: -o-crisp-edges; /* Opera */
      //image-rendering: -webkit-optimize-contrast; /* Webkit (non-standard naming) */
      image-rendering: crisp-edges;
      -ms-interpolation-mode: nearest-neighbor; /* IE (non-standard property) */
    }
  }

  ::v-deep .el-submenu .el-menu {
    .el-menu-item {
      text-indent: 10px;
    }

    .el-menu-item.is-active {
      color: #fff;
      background-color: #2557db;
      border-right: 2px solid #fff;
    }
  }

  .el-menu.el-menu--horizontal {
    display: flex;
    flex-direction: column;

    .el-menu-item {
      height: 100%;
      line-height: 66px;
      padding: 0 30px;
    }
  }
}

.el-menu--vertical .el-menu-item.is-active {
  color: #2557db;
}

.iconfont {
  margin-right: 10px;
  font-size: 24px;
  font-weight: normal;
}
</style>
